import WindowGridIcon from "./window-grid-icon.svg";
import ArrowRightIcon from "./arrow-right-icon.svg";
import ArrowCodeIcon from "./arrow-code-icon.svg";
import PenIcon from "./pen-icon.svg";
import CheckedCircleIcon from "./checked-circle-icon.svg";
import GraduationCapIcon from "./graduation-cap-icon.svg";
import WorkIcon from "./work-icon.svg";
import CalendarGreyIcon from "./calendar-grey-icon.svg";
import WorkGreyIcon from "./work-grey-icon.svg";
import GraduationGreyIcon from "./graduation-cap-grey-icon.svg";
import simran from "./simran1.jpeg";
import rohan from "./rohan1.jpeg";
import AZ900 from "./AZ900.png";
import SC900 from "./SC900.png";
import First from "../Images/Pictures/First.jpg";
import Second from "../Images/Pictures/second.jpg";
import Third from "../Images/Pictures/third.jpg";
import MenuIcon from "../NewImages/Menu.svg";
import ProfileAvatar from "../NewImages/ProfileAvatar.svg";
import ProgrammerIllustration from "../NewImages/ProgrammerIllustration.svg";
import TechDevices from "../NewImages/TechDevices.svg";
import JavaLogo from "../NewImages/JavaLogo.svg";
import ReactLogo from "../NewImages/ReactLogo.svg";
import Frontend from "../NewImages/Frontend.svg";
import Backend from "../NewImages/Backend.svg";
import LocationIcon from "../NewImages/LocationIcon.svg";
import URLIcon from "../NewImages/URLIcon.svg";
import card1 from "../NewImages/card1.jpg";
import card2 from "../NewImages/card2.jpg";
import card3 from "../NewImages/card3.jpg";
import card4 from "../NewImages/card4.jpg";
import Gmail from "../NewImages/Gmail.svg";
import Github from "../NewImages/Github.svg";
import LinkedIn from "../NewImages/LinkedIn.svg";

export const AllImages = {
  WindowGridIcon,
  ArrowRightIcon,
  ArrowCodeIcon,
  PenIcon,
  CheckedCircleIcon,
  GraduationCapIcon,
  WorkIcon,
  CalendarGreyIcon,
  WorkGreyIcon,
  GraduationGreyIcon,
  simran,
  AZ900,
  SC900,
  First,
  Second,
  Third,
  rohan,
  MenuIcon,
  ProfileAvatar,
  ProgrammerIllustration,
  TechDevices,
  JavaLogo,
  ReactLogo,
  Frontend,
  Backend,
  LocationIcon,
  URLIcon,
  card1,
  card2,
  card3,
  card4,
  Gmail,
  Github,
  LinkedIn,
};
